import { render } from "./PersonalReservation.vue?vue&type=template&id=18717e3b"
import script from "./PersonalReservation.vue?vue&type=script&lang=js"
export * from "./PersonalReservation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__